if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /*-----------------------START: Correct code for add to cart compementary Product----------------------*/
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const complementaryProductSection = document.querySelector('.accessories_complementary_product');
        const checkedProducts = [];
        const checkedProductIds = [];
        const checkedProductInventoryQuantities = [];

        if (complementaryProductSection) {
          const productCheckboxes = complementaryProductSection.querySelectorAll('.products_checkbox:checked');
          if (productCheckboxes.length > 0) {
            productCheckboxes.forEach(checkbox => {
              const productUrl = checkbox.dataset.url;
              const productId = checkbox.dataset.id;
              const productInventoryQuantity = checkbox.dataset.inventoryQuantity;

              if (productUrl) {
                checkedProducts.push(productUrl);
              } else {
                console.error("No product URL found for checked checkbox.");
              }

              if (productId) {
                checkedProductIds.push(productId);
              } else {
                console.error("No product ID found for checked checkbox.");
              }

              if (productInventoryQuantity) {
                checkedProductInventoryQuantities.push({
                  id: productId,
                  inventoryQuantity: parseInt(productInventoryQuantity, 10) // Push product ID and inventory quantity into separate array
                });
              } else {
                console.error("No inventory quantity found for checked checkbox.");
              }
            });
          } else {
            console.log("No checkboxes are checked in complementary product section.");
          }
        } else {
          console.log("No complementary product section found.");
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const addProductsSequentially = (productUrls) => {
              if (productUrls.length === 0) {
                return Promise.resolve();
              }

              const productUrl = productUrls.shift();

              return fetch(`${productUrl}.js`)
                .then(res => res.json())
                .then(product => {
                  const variantId = product.variants.length > 0 ? product.variants[0].id : product.id;
                  return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                  })
                  .then(res => {
                    if (!res.ok) {
                      return res.text().then(text => { throw new Error(text); });
                    }
                    return res.json();
                  })
                  .then(() => addProductsSequentially(productUrls)) // Recursively add the next product
                  .catch(err => {
                    console.error('Error adding checked product to cart:', err.message);
                    throw err;
                  });
                });
            };

            return addProductsSequentially([...checkedProducts])
              .then(() => {
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                }

                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }

                fetch('/cart.js')
                  .then(response => response.json())
                  .then(data => {
                    const products = data.items.map(item => ({
                      title: item.title,
                      url: item.url,
                      quantity: item.quantity,
                      id: item.id
                    }));

                    console.log('Products in cart:', products);

                    const matchedProducts = checkedProductIds.map(productId => {
                      const product = products.find(item => item.id == productId);
                      if (product) {
                        return product;
                      } else {
                        console.log(`Product ID: ${productId} is not in the cart.`);
                        return null;
                      }
                    }).filter(product => product !== null);

                    matchedProducts.forEach(product => {
                      const matchedInventoryProduct = checkedProductInventoryQuantities.find(item => item.id == product.id);
                      if (matchedInventoryProduct) {
                        const remainingQuantity = matchedInventoryProduct.inventoryQuantity - product.quantity;
                        if (remainingQuantity < 1) {
                          const productCheckbox = document.querySelector(`.products_checkbox[data-id='${product.id}']`);
                          if (productCheckbox) {
                            const trackInventory = productCheckbox.getAttribute('data-inventory_track_or_notContinue');
                            if (trackInventory !== null) {
                              productCheckbox.classList.add('sold_out_complementary_product');
                              productCheckbox.checked = false;
                              productCheckbox.setAttribute('disabled', 'disabled');
                              productCheckbox.removeAttribute('checked');

                              // Remove highlight class from parent element
                              const parentItem = productCheckbox.closest('.complementary_product_item');
                              if (parentItem) {
                                parentItem.classList.remove('highlight_border');
                                parentItem.style.pointerEvents = 'none';
                              }
                            }
                          }
                        }
                      } else {
                        console.log(`Product ID: ${product.id} is not present in checkedProductInventoryQuantities.`);
                      }
                    });

                  })
                  .catch(error => {
                    console.error('Error fetching cart data:', error);
                  });

              })
              .catch(err => console.error('Error adding products to cart:', err));
          })
          
          
          .catch((e) => {
            console.error('Primary cart add error:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /*-----------------------END: Correct code for add to cart compementary Product----------------------*/
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

    }
  );
}
